import SubscriptionHandler from './SubscriptionHandler';

export default SubscriptionHandler;
